const env = {
  getters: {
    isDebugMode() {
      return process.env.VUE_APP_DEBUG === "true";
    },
    shouldDoAuth() {
      return process.env.VUE_APP_DO_AUTH === "true";
    },
    useDatastore() {
      return process.env.VUE_APP_USE_DATASTORE === "true";
    },
    showNavbar() {
      return process.env.VUE_APP_SHOW_NAVBAR === "true";
    },
    publicKey() {
      return process.env.VUE_APP_PUBLIC_KEY ?? "";
    }
  }
};

export default env;
